import 'whatwg-fetch';
import RequestError from './RequestError';

const NODE_ENV = process.env.REACT_APP_ENV;

export const DOMAIN = NODE_ENV === 'production' ? process.env.REACT_APP_PROD_DOMAIN : process.env.REACT_APP_DEVELOP_DOMAIN || '';

function parseResponse(response) {
  return response.text().then(text => ({
    status: response.status,
    statusText: response.statusText,
    body: text,
  }));
}

function checkStatus({ status, statusText, body }) {
  let json;
  try {
    json = JSON.parse(body);
  } catch (e) {}
  if (status < 200 || status >= 300) {
    return Promise.reject(new RequestError(statusText, status, body, json));
  }
  return json;
}

export default function request(url, options = {}) {
  return fetch(DOMAIN + url, options)
    .then(parseResponse)
    .then(checkStatus);
}
